module.exports = __webpack_public_path__ + "img/mostaza.5338476e.png";